import React from "react";
import Animation from "Components/Animation";
// import VIPLoading from "Assets/Img/vip-loading.json";
import VIPOLoading from "Assets/Img/vipo-loading.json";
import VIPPLoading from "Assets/Img/vipp-loading.json";
import VIPGenericLoading from "Assets/Img/vip-generic-loading.json";
import EnrollmentLoading from "Assets/Img/loading.json";
import { PRODUCTTYPES } from "Utils/Constants";
import VIPPreferredLogo from "Assets/Img/vipp-logo.png";
import VIPOnlineLogo from "Assets/Img/vipo-logo.png";
import useSession from "Utils/Hooks/useSession";

/**
 *
 * @param {Loading.defaultProps} props
 * @returns
 */
const Loading = (props) => {
  const { session } = useSession();
   const { height } = { height: 200, ...props };
   const { width } = { width: 200, ...props };
   const { isEnrollment } = { isEnrollment: false, ...props };

  const isVIPPreferred = session?.productType === PRODUCTTYPES.PREFERRED;
  const productType = isVIPPreferred ? 'VIP Preferred' : 'VIP Online';
  const logoSrc = isVIPPreferred ? VIPPreferredLogo : VIPOnlineLogo;
  var loadingLogo = VIPGenericLoading;
  if (session?.productType)
  {
    if (session.productType === session.patronProductType)
    {
      loadingLogo = session.productType === PRODUCTTYPES.PREFERRED ? VIPPLoading : VIPOLoading;
    }
  }
  const animProps = {
    animationData: isEnrollment ? VIPGenericLoading : loadingLogo,
    height: height,
    width: width,
    style: props.style,
    isLoop: true,
  };

  return (
    <>
      {props.isEnrollment && (
        <div className="enrollment-header">
          <img
            className="vip-preferred"
            src={logoSrc}
            alt={productType}
          ></img>
          <br />
        </div>
      )}
      <Animation {...animProps} />
    </>
  );
};
export default Loading;
